(function () {
  const mobile = () => window.matchMedia('(max-width: 1099px)').matches;

  function buildOverlay() {
    let overlay = document.querySelector('.uwaga-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'uwaga-overlay';
      document.body.appendChild(overlay);
    }
    return overlay;
  }

  function initSizeDrawer() {
    if (!mobile() || !document.body.classList.contains('template-product')) return;
    const picker = document.querySelector('variant-radios.product-parameters--button');
    if (!picker || picker.dataset.uwagaDrawer === 'true') return;
    const fieldsets = Array.from(picker.querySelectorAll('.product-form__controls'));
    const sizeFieldset = fieldsets.find((item) => {
      const legend = item.querySelector('legend');
      return legend && /size|taglia/i.test(legend.textContent);
    });
    if (!sizeFieldset) return;
    picker.dataset.uwagaDrawer = 'true';
    sizeFieldset.classList.add('uwaga-size-drawer');
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'uwaga-size-close';
    close.setAttribute('aria-label', 'Close size selector');
    close.textContent = '×';
    sizeFieldset.prepend(close);
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'uwaga-size-trigger';
    const checked = sizeFieldset.querySelector('input:checked');
    trigger.textContent = checked ? `SIZE: ${checked.value}` : 'SELECT SIZE';
    picker.insertBefore(trigger, sizeFieldset);
    const overlay = buildOverlay();
    const closeDrawer = () => {
      sizeFieldset.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
    };
    trigger.addEventListener('click', () => {
      sizeFieldset.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
    });
    close.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    sizeFieldset.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"]')) {
        trigger.textContent = `SIZE: ${event.target.value}`;
        closeDrawer();
      }
    });
  }

  function initLightbox() {
    if (!mobile() || !document.body.classList.contains('template-product')) return;
    const gallery = document.querySelector('.product__media-list');
    if (!gallery || gallery.dataset.uwagaLightbox === 'true') return;
    const images = Array.from(gallery.querySelectorAll('.product__media img')).map((img) => img.currentSrc || img.src).filter(Boolean);
    if (!images.length) return;
    gallery.dataset.uwagaLightbox = 'true';
    let current = 0;
    const open = document.createElement('button');
    open.type = 'button';
    open.className = 'uwaga-gallery-open';
    open.setAttribute('aria-label', 'Open gallery');
    open.textContent = '+';
    gallery.appendChild(open);
    const lightbox = document.createElement('div');
    lightbox.className = 'uwaga-lightbox';
    lightbox.innerHTML = '<button type="button" class="uwaga-lightbox-close" aria-label="Close gallery">×</button><button type="button" class="uwaga-lightbox-prev" aria-label="Previous image">‹</button><img alt=""><button type="button" class="uwaga-lightbox-next" aria-label="Next image">›</button>';
    document.body.appendChild(lightbox);
    const image = lightbox.querySelector('img');
    const render = () => { image.src = images[current]; };
    open.addEventListener('click', () => {
      current = 0;
      render();
      lightbox.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
    });
    lightbox.querySelector('.uwaga-lightbox-close').addEventListener('click', () => {
      lightbox.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
    });
    lightbox.querySelector('.uwaga-lightbox-prev').addEventListener('click', () => {
      current = (current - 1 + images.length) % images.length;
      render();
    });
    lightbox.querySelector('.uwaga-lightbox-next').addEventListener('click', () => {
      current = (current + 1) % images.length;
      render();
    });
  }

  function init() {
    initSizeDrawer();
    initLightbox();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
